import { TReduxActions } from '../../actions';
import { EMapSelectionActionType } from '../../actions/mapSelection/types';
import { EAddToFavoritesActionTypes } from '../../actions/newFavorites/addToFavorite';
import { ERemoveFromFavoritesActionTypes } from '../../actions/newFavorites/removeFromFavorite';
import { EPreviewOffersActionType } from '../../actions/previewOffers';
import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { EFetchStatus } from '../../types/listingOffers';
import { IPreviewOffersState } from '../../types/previewOffers';
import { patchOfferFavorite } from '../../utils/patchOfferFavorite';

export const defaultState: IPreviewOffersState = {
  status: EFetchStatus.INITIAL,
  offers: [],
};

/**
 * Добавляет объявления, которых ещё нет в хранилище: один id - одна запись, в том числе при повторах
 * внутри offers. Если добавить нечего, возвращает тот же массив.
 */
function appendNewOffers(
  storedOffers: IDailyRentOfferForMobileSite[],
  offers: IDailyRentOfferForMobileSite[],
): IDailyRentOfferForMobileSite[] {
  const knownIds = new Set(storedOffers.map(offer => offer.id));
  const newOffers = offers.filter(offer => {
    if (knownIds.has(offer.id)) {
      return false;
    }

    knownIds.add(offer.id);

    return true;
  });

  return newOffers.length === 0 ? storedOffers : [...storedOffers, ...newOffers];
}

/**
 * Объявления выбранного пина для превью (почему своё хранилище - см. IPreviewOffersState).
 * Ведомый слайс: главным остаётся state.map.selection. Актуальность ответа бека проверяет
 * thunk loadPreviewOffers по selection.
 */
export function previewOffersReducer(
  state: IPreviewOffersState = defaultState,
  action: TReduxActions,
): IPreviewOffersState {
  switch (action.type) {
    case EPreviewOffersActionType.Request:
      return { ...state, status: EFetchStatus.LOADING };

    case EPreviewOffersActionType.Add: {
      const offers = appendNewOffers(state.offers, action.payload);

      return offers === state.offers ? state : { ...state, offers };
    }

    case EPreviewOffersActionType.Success:
      return { status: EFetchStatus.SUCCESS, offers: appendNewOffers(state.offers, action.payload) };

    case EPreviewOffersActionType.Failure:
      return { ...state, status: EFetchStatus.FAILURE };

    case EMapSelectionActionType.Changed: {
      if (action.payload === null) {
        return defaultState;
      }

      // В хранилище остаются только офферы выбранного пина: листание внутри пина его не трогает,
      // выбор другого пина - очищает.
      const selectedIds = action.payload.feature.properties.offers.map(offer => offer.realtyId);
      const offers = state.offers.filter(offer => selectedIds.includes(offer.id));

      return offers.length === state.offers.length ? state : { ...state, offers };
    }

    // Избранное правится везде, где лежит оффер: в хранилище превью тоже.
    case EAddToFavoritesActionTypes.Success:
    case ERemoveFromFavoritesActionTypes.Success: {
      const offers = patchOfferFavorite(state.offers, action.payload.offerId, action.payload.isFavorite);

      return offers === state.offers ? state : { ...state, offers };
    }

    default:
      return state;
  }
}
